import styled from '@emotion/styled'
import { PrismicRichText } from '@prismicio/react'
import { OVERLAY_TEXT_BOX_PADDING } from '../../../theme/theme'
import { ScrollOverMediaDocumentDataCoversItem } from '../../../../types.generated'
import { asText } from '@prismicio/client'
import {
  FadeInParagraphByParagraph,
  FadeInWholeBlock,
} from './effects/RichTextEffects'

export interface CoversInterface {
  covers: ScrollOverMediaDocumentDataCoversItem[]
}

export const hasCovers = (
  covers: ScrollOverMediaDocumentDataCoversItem[]
): boolean => {
  if (!covers || covers.length === 0) {
    return false
  }

  if (covers[0].text.length === 0) {
    return false
  }

  return true
}

export function Covers(props: CoversInterface) {
  return (
    <>
      {props.covers?.map(
        (cover: ScrollOverMediaDocumentDataCoversItem, index: number) => {
          const coverContainerCss = asText(cover.cover_container_css)

          if (cover.effect_type === 'fade_in_paragraph_by_paragraph') {
            return (
              <CoverContainer coverContainerCss={coverContainerCss} key={index}>
                <CoverContent>
                  <FadeInParagraphByParagraph richText={cover.text} />
                </CoverContent>
                <CoverCaption>
                  <FadeInParagraphByParagraph richText={cover.caption} />
                </CoverCaption>
              </CoverContainer>
            )
          }

          if (cover.effect_type === 'fade_in_whole_block') {
            return (
              <CoverContainer coverContainerCss={coverContainerCss} key={index}>
                <CoverContent>
                  <FadeInWholeBlock>
                    <PrismicRichText field={cover.text} />
                  </FadeInWholeBlock>
                </CoverContent>

                <CoverCaption>
                  <FadeInWholeBlock>
                    <PrismicRichText field={cover.caption} />
                  </FadeInWholeBlock>
                </CoverCaption>
              </CoverContainer>
            )
          }

          return (
            <CoverContainer coverContainerCss={coverContainerCss} key={index}>
              <CoverContent>
                <PrismicRichText field={cover.text} />
              </CoverContent>
              <CoverCaption>
                <PrismicRichText field={cover.caption} />
              </CoverCaption>
            </CoverContainer>
          )
        }
      )}
    </>
  )
}

const CoverContainer = styled.div<{ coverContainerCss: string }>`
  position: relative;
  width: 100%;
  min-height: 100vh;
  pointer-events: none;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.scrollOverMediaCoverContainerCss}

  ${({ coverContainerCss }) => coverContainerCss}
`

const BaseStyle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: ${OVERLAY_TEXT_BOX_PADDING};

  width: 100%;
  max-width: min(850px, 100%);
  color: white;

  overflow: hidden;
  hyphens: auto;

  background: black;
  * {
    color: white;
  }
`

const CoverContent = styled(BaseStyle)`
  * {
    pointer-events: auto;
  }
  ${({ theme }) => theme.scrollOverMediaCoverCss}
`

const CoverCaption = styled(CoverContent)`
  * {
    pointer-events: auto;
  }
  ${({ theme }) => theme.scrollOverMediaCoverCaptionCss}
`
